<template>
<a-row :gutter="24" class="new-row">
  <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
    <a-row :gutter="10" class="new-row">
      <a-card :bordered="false" class="new-tree-card">
          <!-- 按钮操作区域 -->
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex;margin-top: 10px;">
              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-row>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
  <a-card :bordered="false" class="new-table-card">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <j-input :placeholder="$t('请输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <j-input :placeholder="$t('请输入用户编号模糊查询')" v-model="queryParam.userId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户姓名')">
              <j-input :placeholder="$t('请输入用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户地址')">
              <j-input :placeholder="$t('请输入用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户手机号')">
                <j-input :placeholder="$t('请输入用户手机号模糊查询')" v-model="queryParam.userPhone"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户价格名称')">
                <a-select v-model="queryParam.userPriceId" :placeholder="$t('请输入用户价格名称')">
                  <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                    {{data.wtName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用户用水状态">
                <j-dict-select-tag v-model="queryParam.userState" placeholder="请选择用水状态" dictCode="user_state" style="width:100%"/>
              </a-form-item>
            </a-col> -->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button type="primary" icon="download" @click="handleExportXls('缴费管理')">导出</a-button>-->
      <a-button type="primary" @click="readcard(1)" v-has="'charge:cardpay'">{{ $t('用户卡充值') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        <span style="float:right;">
          <a @click="loadData()"><a-icon type="sync" />{{ $t('刷新') }}</a>
          <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
            <template slot="content">
              <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                <a-row>
                  <template v-for="item in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                    </template>
                  </template>
                </a-row>
              </a-checkbox-group>
            </template>
          </a-popover>
        </span>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :components="drag(columns)"
        @change="handleTableChange">
        <div slot="filterDropdown">
          <a-card>
            <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
              <a-row>
                <template v-for="item in defColumns">
                  <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                    <a-col :span="12" :key="item.key">
                      <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </a-checkbox-group>
          </a-card>
        </div>
        <span slot="wtPriceSlot" slot-scope="text, record">
          <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
          <span v-else>--</span>
        </span>
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="userPayStateSlot" slot-scope="text">
          <a-button :class="text === 1?'normalbg-status':text === 0?'unactivebg-status':''">
            {{text===1?$t('是'):text===0?$t('否'):'--'}}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record" class="action">
          <a @click="toggleModal(record)" v-has="'charge:pay'" :disabled="record.userPayState === 0||record.userState === 0">{{ $t('缴费') }}</a>
          <a @click="replenishment(record)" v-has="'charge:replenishment'" :disabled="record.userPayState === 0||record.userState === 0">{{ $t('补水') }}</a>
          <a @click="returnPremium(record)" v-has="'charge:returnPremium'" :disabled="record.userPayState === 0||record.userState === 0">{{ $t('退费') }}</a>
          <a @click="revocation(record)" v-has="'charge:revocation'" :disabled="record.userPayState === 0||record.userState === 0">{{ $t('撤销') }}</a>
          <!-- <a-popconfirm title="确定对该用户下发开阀命令吗?" @confirm="() =>handleOpenCloseValve(record,1)">
            <a v-has="'meteruser:openValve'">开阀</a>
          </a-popconfirm>
          <a-popconfirm title="确定对该用户下发关阀命令吗?" @confirm="() =>handleOpenCloseValve(record,2)">
            <a v-has="'meteruser:closeValve'">关阀</a>
          </a-popconfirm> -->
          
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="meterUserOpreateDetail(record)">{{ $t('用户操作记录') }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <meter-user-opreate-detail-modal ref="meterUserOpreateDetailModal"></meter-user-opreate-detail-modal>
    <meter-pay-modal ref="payForm" @ok="payFormOk"></meter-pay-modal>
    <meter-returnPremium-modal ref="returnPremiumForm" @ok="returnPremiumFormOk"></meter-returnPremium-modal>   <!--退费-->
    <meter-revocation-modal ref="revocationForm" @ok="revocationFormOk"></meter-revocation-modal>    <!--撤销-->
    <meter-replenishment-modal ref="replenishmentForm" @ok="replenishmentFormOk"></meter-replenishment-modal>   <!--补水-->
    <meter-rfidToolMgr-modal ref="rfidToolMgrForm" @ok="rfidToolMgrFormOk"></meter-rfidToolMgr-modal> <!-- 用户卡充值 -->
  </a-card>
  </a-col>
</a-row>
</template>
<script>
  import { putAction,getAction,postAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUserOpreateDetailModal from './modules/MeterUserOpreateDetailModal'
  import MeterPayModal from './modules/MeterPayModal'
  import MeterReturnPremiumModal from './modules/MeterReturnPremiumModal'
  import MeterRevocationModal from './modules/MeterRevocationModal'
  import MeterReplenishmentModal from './modules/MeterReplenishmentModal'
  import MeterRfidToolMgrModal from '../oldMeterCompatibleManagement/modules/RfidToolMgrModal'
  import JInput from '@/components/jeecg/JInput'
  import configService from '@/utils/service/config.service'
  import { listSize,paramsToFormData } from '@/utils/util'
  import Vue from 'vue'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  import {isUndefinedAndNull,isUndefined,isEmptyObject} from'@/utils/validate'
  
  export default {
    name: 'MeterUserinfoList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterUserOpreateDetailModal,
      MeterPayModal,
      // JInput,
      MeterReturnPremiumModal,
      MeterRevocationModal,
      MeterReplenishmentModal,
      MeterRfidToolMgrModal,
      JInput
    },
    data () {
      return {
        //表头
        columns:[],
        pocket:true,
        collapsed: false,
        //列设置
        settingColumns:[],
        data :[],
        item:{
        id:'',
        userMeterStartNum:'',
        userName:'',
        userId:''
        },
        visible: false,
        userPriceCode:[], // 价格编码
        description: 'meter_userinfo管理页面',
        url: {
          list: "/jeecg-charge/meter/meterUserinfo/list",
          delete: "/jeecg-charge/meter/meterUserinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
          doActivate:"/jeecg-charge/meter/userPay/doActivate",
          UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list",
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list",
          sendNewCommand: "/model/partCommand/sendCommand",
          sendOldCommand: "/jeecg-charge/meter/command/addCommand",
          sendDykjCommand: "/jeecg-charge/meter/dykj/addCommand",
          jqAddCommand_y10_qn: "/jeecg-charge/meter/command/jqAddCommand_y10_qn",
          scAddCommand_y17Or18_N: '/jeecg-charge/meter/command/scAddCommand_y17Or18_N',
          scAddCommandY18_N: '/jeecg-charge/meter/command/scAddCommandY18_N'
        },
        dictOptions:{},
        queryParam: {userState: 1},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true
            // sorter: (a, b) => a.meterId - b.meterId,
          },{
            title: this.$t('用户编号'),
            align:"center",
            // sorter: true,
            dataIndex: 'userId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width: 150,
            ellipsis: true
          },/*{
            title:'用户手机号',
            align:"center",
            dataIndex: 'userPhone',
            width: 150,
            ellipsis: true
          },*/{
            title: this.$t('价格信息'),
            align:"center",
            dataIndex:'wtPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'wtPriceSlot' },
          },{
            title: this.$t('账户余额'),
            align:"center",
            dataIndex: 'userAccountBalance',
            customRender:function (t,r,index) {
              return t.toFixed(2);
            },
            width: 100,
            ellipsis: true
          },{
            title: this.$t('累计用量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse',
            width: 100,
            ellipsis: true
          },{
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender:(t,r,index) => {
              let data = Mn100FkStatusObj;
              if(isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            width: 200,
            ellipsis: true,
            customRender:function (t,r,index) {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },/*{
            title:'水表地址',
            align:"center",
            dataIndex: 'userMeterAddr',
            ellipsis: true
          },
          {
            title:'身份证号',
            align:"center",
            dataIndex: 'userIdNumber',
            width: 150,
            ellipsis: true
          },
          */
          // {
          //   title:'区域名称',
          //   align:"center",
          //   dataIndex: 'userAreaName',
          //   width: 150,
          //   ellipsis: true
          // },
          {
            title: this.$t('是否允许缴费'),
            align:"center",
            dataIndex: 'userPayState',
            width: 120,
            ellipsis: true,
            scopedSlots: { customRender: 'userPayStateSlot' },
          }
          ,{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:230,
            scopedSlots: { customRender: 'action'}
          }
        ]
      },
    },
    methods: {
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        }) 
      },
      toggleModal(record) {    // 缴费页面点击跳转
        this.$refs.payForm.edit(record)
        this.$refs.payForm.title = this.$t('缴费')
      },
      meterUserOpreateDetail(record) {
        this.$refs.meterUserOpreateDetailModal.edit(record)
        this.$refs.meterUserOpreateDetailModal.title = this.$t('用户操作记录')
      },
      replenishment(record) { //补水界面点击跳转
        this.$refs.replenishmentForm.edit(record)
        this.$refs.replenishmentForm.title = this.$t('补水')
      },
      returnPremium(record) { //退费界面点击跳转
        this.$refs.returnPremiumForm.edit(record)
        this.$refs.returnPremiumForm.title = this.$t('退水')
      },
      revocation(record) { //撤销界面点击跳转
        this.$refs.revocationForm.edit(record)
        this.$refs.revocationForm.title = this.$t('撤销')
      },
      readcard(arg){ //用户卡充值
        this.$refs.rfidToolMgrForm.title = this.$t('用户卡充值')
        this.$refs.rfidToolMgrForm.edit(arg);
      },
      rfidToolMgrFormOk(){
      },
      payFormOk() {
        this.loadData();
      },
      replenishmentFormOk() {  //补水
        this.loadData();
      },
      returnPremiumFormOk() {   //退费
        this.loadData();
      },
      revocationFormOk() {  //撤销
        this.loadData();
      },
      activate(record) {  // 激活页面点击事件
        this.visible = true;
        this.item.id = record.id
        this.item.userName = record.userName
        this.item.userId = record.userId
      },
      handleOk() {   // 激活页面提交
        this.visible = false;
        const that = this;
        let data = this.item
        console.log("激活提交数据",data)
        putAction(this.url.doActivate,data).then((res)=>{
          if(res.success){
            console.log(res)
            that.$message.success(res.message);
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
          this.loadData();
        })
      },
      handleOpenCloseValve(record,type) {debugger
        console.log(record.meterType)
        let params = {}
        params.meterId = record.meterId

        if(record.meterType == 'WN100') {
          // type:1开阀，2关阀
          if(type == 1) {
            params.tag = 0
            params['20'] = 4
          }else if(type == 2) {
            params.tag = 0
            params['20'] = 3
          }
          this.sendNewCommand(params)
        }else if(record.meterType == 'MN100') {
          let cmdParam = {}
          if(type == 1) {
            cmdParam.valveOperate = 'A4';
            params.cmd = 'a017_A4';
          }else if(type == 2) {
            cmdParam.valveOperate = 'A5';
            params.cmd = 'a017_A5';
          } 
          params.cmdParam = JSON.stringify(cmdParam);
          this.sendOldCommand(params)
        }else if(record.meterType == 'MN100-2D') {
          let cmdParam = {deviceCode: record.meterId}
          if(type == 1) {
            // 开阀
            cmdParam.type = '1';
            params.cmd = 'a017';
          }else if(type == 2) {
            // 关阀
            cmdParam.type = '0';
            params.cmd = 'a017';
          } 
          params.cmdParam = JSON.stringify(cmdParam);
          this.sendDykjCommand(params)
        }else if(record.meterType == 'Y10-QN') {
          let cmdParam = {deviceCode: record.meterId}
          if(type == 1) {
            // 开阀
            cmdParam.valveOperate = '1';
            params.cmd = 'a017';
          }else if(type == 2) {
            // 关阀
            cmdParam.valveOperate = '0';
            params.cmd = 'a017';
          } 
          params.cmdParam = JSON.stringify(cmdParam);
          this.sendDy10qnCommand(params)
        }else if(record.meterType == 'Y17-N') {
          let cmdParam = {deviceCode: record.meterId}
          if(type == 1) {
            // 开阀
            cmdParam.valveOperate = '1';
            params.cmd = 'a017';
          }else if(type == 2) {
            // 关阀
            cmdParam.valveOperate = '0';
            params.cmd = 'a017';
          } 
          params.cmdParam = JSON.stringify(cmdParam);
          this.sendDy17nCommand(params)
        }else if(record.meterType == 'Y18-N') {
          let cmdParam = {deviceCode: record.meterId}
          if(type == 1) {
            // 开阀
            cmdParam.valveOperate = '1';
            params.cmd = 'a017';
          }else if(type == 2) {
            // 关阀
            cmdParam.valveOperate = '0';
            params.cmd = 'a017';
          } 
          params.cmdParam = JSON.stringify(cmdParam);
          this.sendDy18nCommand(params)
        }
        
      },
      // 新协议下发命令
      sendNewCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.sendNewCommand, formData).then((res) => {
          if (res.success && res.code==0) {
            this.$message.success(this.$t("命令添加成功"))
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      // 老协议下发命令
      sendOldCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.sendOldCommand, formData).then((res) => {
          if (res.success && res.code == 0) {
            this.$message.success(res.message || this.$t("命令添加成功"))
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // MN100-2D端云科技下发命令
      sendDykjCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.sendDykjCommand, formData).then((res) => {
          if (res.success && res.code == 0) {
            this.$message.success(res.message || this.$t("命令添加成功"))
          } else {
            this.$message.error(res.message)
          }
        })
      },
      sendDy10qnCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.jqAddCommand_y10_qn, formData).then((res) => {
          if (res.success && res.code == 0) {
            this.$message.success(res.message || this.$t("命令添加成功"))
          } else {
            this.$message.error(res.message)
          }
        })
      },
      sendDy17nCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.scAddCommand_y17Or18_N, formData).then((res) => {
          if (res.success && res.code == 0) {
            this.$message.success(res.message || this.$t("命令添加成功"))
          } else {
            this.$message.error(res.message)
          }
        })
      },
      sendDy18nCommand(params) {
        let formData = paramsToFormData(params)
        postAction(this.url.scAddCommandY18_N, formData).then((res) => {
          if (res.success && res.code == 0) {
            this.$message.success(res.message || this.$t("命令添加成功"))
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
      this.queryUserPriceCode();
    },
  }
</script>
<style scoped>
  .background{
  background-color:rgb(238,238,238)
  }
  .drawer-bootom-button {
    bottom: 0;
    width: 100%;
    /* border-top: 0px solid #e8e8e8; */
    padding: 18px 18px 18px 22px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 10px;
    margin-top: 10px;
  }
  .aa{
    margin: 0 auto;
    width: 20px;
    line-height: 24px;

    /* background-color: brown; */
    /* margin-right: 200px; */
    /* text-align: right; */
  }
  .card{
    background-color: brown;
    padding: 0;
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>